import api from "utils/api";

export const getPaymentOrderHistory = async (params = {}) => {
  try {
    const response = await api.get("/payments/order-history", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
